let userId, userToken, url, resellerId;

if (localStorage.getItem("login") != null) {
  const lStorage = JSON.parse(localStorage.getItem("login"));
  userId = lStorage.user.userId;
  userToken = lStorage.token;
  url = lStorage.url;
  resellerId = lStorage.user.reseller_id;
  
} else {
  // console.log('User is null');
}

export { userId, userToken, url, resellerId };
